var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('topBox',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}]}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }